export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceLink.vue?vue&type=template&id=241363d9"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ResourceLink.vue?vue&type=template&id=241363d9
// module id = 334
// module chunks = 0